var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.999,
    height: 48.001,
    viewBox: "0 0 47.999 48.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.001,
    cy: 38.546,
    r: 0.728,
    fill: "#1a171b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.364,6.789H38.182L37.327.627A.729.729,0,0,0,36.606,0H11.394a.73.73,0,0,0-.721.627L9.818,6.789H3.637A3.641,3.641,0,0,0,0,10.426V38.545a3.641,3.641,0,0,0,3.637,3.637H14.545v4.363H9.454a.728.728,0,0,0,0,1.456h29.09a.728.728,0,1,0,0-1.456H33.453V42.182H44.362A3.641,3.641,0,0,0,48,38.545V10.426A3.638,3.638,0,0,0,44.364,6.789ZM12.028,1.455H35.972L40.619,34.91H7.381ZM1.455,10.426A2.185,2.185,0,0,1,3.638,8.244H9.617L5.914,34.91H1.456V10.426ZM32,46.545H16V42.182H32Zm14.545-8a2.185,2.185,0,0,1-2.182,2.182H3.637a2.186,2.186,0,0,1-2.183-2.182V36.363H46.545v2.182Zm0-3.635H42.089l-3.7-26.666h5.979a2.185,2.185,0,0,1,2.182,2.182Z",
    fill: "#1a171b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.022,10.4V8.082a.728.728,0,0,0-1.455,0V10.4a7.434,7.434,0,1,0,14.868,0V8.082a.728.728,0,0,0-1.455,0V10.4a5.979,5.979,0,1,1-11.958,0Z",
    fill: "#1a171b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87,8.324A.729.729,0,0,0,15.6,7.6a1.7,1.7,0,1,1,3.393,0,.728.728,0,0,0,1.456,0,3.152,3.152,0,1,0-6.3,0A.726.726,0,0,0,14.87,8.324Z",
    fill: "#1a171b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.283,8.324a.729.729,0,0,0,.728-.727,1.7,1.7,0,1,1,3.393,0,.728.728,0,0,0,1.455,0,3.151,3.151,0,1,0-6.3,0A.726.726,0,0,0,28.283,8.324Z",
    fill: "#1a171b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.528db90821afcdff051b50763c58c9f0.svg";
export { ForwardRef as ReactComponent };